import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=67cef20c"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=67cef20c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports